import { useEffect, useState } from 'react';

const links = [
  { label: '编辑精选', href: '#picks' },
  { label: '最新电影', href: '#latest' },
  { label: '电影排行榜', href: '#ranking' },
  { label: '高分佳作', href: '#toprated' },
  { label: '冷门宝藏', href: '#gems' },
  { label: '影迷热议', href: '#talk' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-background-50/95 border-b border-background-200 backdrop-blur' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[68px] items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
          <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-film-line text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-semibold text-foreground-950">金桔影院</span>
            <span className="mt-1 text-[10px] tracking-widest text-foreground-500">JINJU CINEMA</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition hover:bg-background-100 hover:text-primary-700 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden sm:inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600 cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-bookmark-line text-base"></i>
            </span>
            订阅片单
          </a>
          <button
            type="button"
            aria-label="展开菜单"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {open ? (
        <div className="md:hidden border-t border-background-200 bg-background-50/95 backdrop-blur px-4 pb-4 pt-2">
          <nav className="flex flex-col">
            {links.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-700 transition hover:bg-background-100 hover:text-primary-700 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 cursor-pointer"
            >
              订阅片单
            </a>
          </nav>
        </div>
      ) : null}
    </header>
  );
}